<template>
  <div :class="prefixCls">
      <tree-node
        v-for="(item, i) in stateTree"
        :show-checkbox="showCheckbox"
        :multiple="multiple"
        :is-check="item.isCheck"
        :data="item"
        :key="i"
      ></tree-node>
  </div>
</template>

<script>
import treeNode from "./node";
const prefixCls = "uf-tree";
export default {
  name: "tree",
  props: {
    showCheckbox: {//是否显示多选checkbox, 单选下无效
      type: Boolean,
      default: true
    },
    data: {
      type: Array,
      default: () => {}
    },
    childrenKey: {
      type: String,
      default: "children"
    },
    multiple: { //是否多选
      type: Boolean,
      default: true
    },
    loadData: {
      type: Function
    }
    // checkedId: {
    //   type: Array,
    //   default: () => []
    // }
  },
  created() {
    // this.flatState = this.compileFlatState();
  },
  updated() {
    // this.onNodeChange();
  },
  mounted() {
    this.$on("on-radio", this.handleRadio);
    this.$on("on-check", this.handleCheck);
    this.$on("on-all-check", this.handleAllCheck);
    this.$on("cancel", this.handleAllCheck);
    this.$on("checkAllChildren", this.handleAllChildrenCheck);
    this.$on("checkFirstChildren", this.handleFirstChildrenCheck);
    this.$on("on-node-change", this.onNodeChange);
  },
  data() {
    return {
      prefixCls: prefixCls,
      stateTree: this.data,
      flatState: []
    };
  },
  methods: {
    onNodeChange() {
      //当数据发生变化时
      let checkedNodes = this.getCheckedNodes();
      let checkedNodesId = this.getCheckedNodesId();
      // console.log(checkedNodes);
      this.$emit("on-change", checkedNodesId, checkedNodes);
    },
    compileFlatState() {
      //得到一个父级和子集的关系数组
      // console.log("dd")
      let keyCounter = 0;
      let childrenKey = this.childrenKey;
      const flatTree = [];
      function flattenChildren(node, parent) {
        node.nodeKey = keyCounter++;
        flatTree[node.nodeKey] = { node: node, nodeKey: node.nodeKey };
        if (typeof parent != "undefined") {
          flatTree[node.nodeKey].parent = parent.nodeKey;
          flatTree[parent.nodeKey][childrenKey].push(node);
        }
        if (node[childrenKey]) {
          flatTree[node.nodeKey][childrenKey] = [];
          node[childrenKey].forEach(child => flattenChildren(child, node));
        }
      }
      this.stateTree.forEach(rootNode => {
        flattenChildren(rootNode);
      });
      return flatTree;
    },
    getCheckedNodes() {
      //获取被选中的数据
      return this.flatState
        .filter(obj => obj.node.checked)
        .map(obj =>  obj.node);
    },
    getCheckedNodesId() {
      return this.getCheckedNodes().map(obj => {
        return obj.id;
      });
    },
    changeNode(nodeKey) {
      this.handleCheck({ checked: false, nodeKey });
    },
    handleRadio({ checked, nodeKey }) {
      if (typeof nodeKey === "undefined") {
        return;
      }
      const node = this.flatState[nodeKey].node;
      const currentSelectedKey = this.flatState.findIndex(
        obj => obj.node.checked
      );
      if (currentSelectedKey >= 0 && currentSelectedKey !== nodeKey) {
        this.$set(this.flatState[currentSelectedKey].node, "checked", false);
      }
      this.$set(node, "checked", !node.checked);
      this.onNodeChange();
    },
    handleCheck({ checked, nodeKey }) {
      const node = this.flatState[nodeKey].node;
      this.$set(node, "checked", checked);
      this.onNodeChange();
    },
    handleAllCheck({ checked, nodeKey }) {
      const node = this.flatState[nodeKey].node;
      //设置当前节点为选中
      if (node.isCheck) {
        this.$set(node, "checked", checked);
      }
      //向下更新节点
      this.updateTreeDown(node, checked);
      // console.log(this.stateTree);
    },
    handleAllChildrenCheck({ checked, nodeKey }) {
      const node = this.flatState[nodeKey].node;
      //向下更新节点
      if (node[this.childrenKey]) {
        node[this.childrenKey].forEach(child => {
          this.updateTreeDown(child, checked);
        });
      }
    },
    handleFirstChildrenCheck({ checked, nodeKey }) {
      //选中直属下级
      const node = this.flatState[nodeKey].node;
      if (node[this.childrenKey]) {
        node[this.childrenKey].forEach(child => {
          this.$set(child, "checked", checked);
        });
      }
    },
    updateTreeDown(node, checked) {
      if (node.isCheck) {
        //如果可以选择
        this.$set(node, "checked", checked);
      }
      if (node[this.childrenKey]) {
        node[this.childrenKey].forEach(child => {
          this.updateTreeDown(child, checked);
        });
      }
    },
    updateTree(rootNode, checked, nodeKey) {
      // console.log(rootNode.nodeKey, nodeKey)
      if (rootNode.nodeKey === nodeKey) {
        this.$set(rootNode, "checked", true);
      } else {
        this.$set(rootNode, "checked", checked);
      }
      if (rootNode[this.childrenKey]) {
        rootNode[this.childrenKey].forEach(child => {
          this.updateTree(child, checked, nodeKey);
        });
      }
    }
  },
  components: {
    treeNode
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.stateTree = this.data;
        this.flatState = this.compileFlatState();
        this.onNodeChange();
      }
    }
  }
};
</script>
